import React from 'react';
import { dateCreatedFormatter } from 'pages/Admin/Users/UserComponents/UserList/Formatters';
import ReqResTextarea from 'components/integrations/ReqResTextarea';
import { millisecondsToSecondsFormatter } from 'helpers/sf_utils';
import LoadingDashboardTableSkeleton from 'pages/Dashboard/LoadingDashboardTableSkeleton';

const FORMATTER_TYPE = {
    TEXT: 'text',
    DATE: 'date',
    SECONDS: 'seconds',
    REQ_DATA: 'req_data',
    LINK: 'link'
}

const RulesLogTable = ({ row, isBeautify, loading }) => {
    const infoColumns = [
        { key: 'id', text: 'ID', formatter: FORMATTER_TYPE.TEXT },
        { key: 'jira_url', text: 'Jira URL', formatter: FORMATTER_TYPE.LINK },
        { key : 'logs', text: 'Log', formatter: FORMATTER_TYPE.REQ_DATA},
        { key: 'error_logs', text: 'Error Logs', formatter: FORMATTER_TYPE.REQ_DATA },
        
    ]

    const getDataFormatter = (key, value, formatter, isBeautify) => {
        switch (formatter) {
            case FORMATTER_TYPE.TEXT:
                return value;
            case FORMATTER_TYPE.DATE:
                return dateCreatedFormatter(value, {});
            case FORMATTER_TYPE.REQ_DATA:
                return value ? (
                    <ReqResTextarea
                        isBeautify={isBeautify}
                        key={key}
                        val={JSON.stringify(value)}
                    />
                ) : (
                    <div className='dev-dashboard-req-res-body'>--</div>
                );
            case FORMATTER_TYPE.SECONDS:
                return millisecondsToSecondsFormatter(value);
            case FORMATTER_TYPE.LINK:
                return value ? <a href={value} className="text-sfblue" target="_blank">
                    View
                </a> : '--';
            default:
                return value;

        }
    }

    return (
        loading ?
            <LoadingDashboardTableSkeleton rows={2} cols={2} />
            :
            (
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">Key</th>
                            <th scope="col">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        infoColumns.map((column) => {
                            return (
                                <tr key={column.key} style={{ cursor: 'default' }}>
                                    <td className="text-capitalize font-weight-semibold">{column.text}</td>
                                    <td>
                                        {
                                            getDataFormatter(column.key, row?.[column.key], column.formatter, isBeautify) || '--'
                                        }
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            )
    )
}

export default RulesLogTable
